<template>
  <v-card>
    <v-card-title>
      <span class="headline">Edit Password</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <h3>Current Password</h3>
            <v-text-field
              class="mb-7"
              :type="inputTypeOld"
              color="#4dbac0"
              label="Password"
              v-model="inputValueOld"
            ></v-text-field>
            <h3>New Password</h3>
            <v-text-field
              :type="inputTypeNew"
              color="#4dbac0"
              label="Type new password"
              v-model="inputValueNew"
            ></v-text-field>
            <v-text-field
              :type="inputTypeConfirm"
              color="#4dbac0"
              label="Confirm new password"
              v-model="inputValueConfirm"
            ></v-text-field>
            <div class="errors">
                <li v-for="(error, index) in errors" :key="index">{{error}}</li>
              </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="close">Close</v-btn>
      <v-btn color="blue darken-1" text @click="save">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "modal",
  data() {
    return {
      name: "editPassword",
      inputTypeOld: "password",
      inputTypeNew: "password",
      inputTypeConfirm: "password",
      inputValueOld: "",
      inputValueNew: "",
      inputValueConfirm: "",
      errors: new Array()
    };
  },
  methods: {
    close() {
      this.$emit("close", this.name);
      this.clearData();
      this.errors = [];
    },
    save() {
      this.errors = [];

      if (this.inputValueOld == "") {
        this.errors.push("Type your current password");
      }

      if (this.inputValueNew != this.inputValueConfirm) {
        this.errors.push("New passwords do not match");
      }

      if (this.inputValueNew < 8) {
        this.errors.push("New passwords at least 8 characters long");
      }

      if (this.errors.length == 0) {
        this.$store
          .dispatch("updatePassword", {
            password: this.inputValueOld,
            email: this.$store.getters.usermail,
            newpassword: this.inputValueNew,
          })
          .then(() => {
            this.$emit("close", this.name);
            this.clearData();
          })
          .catch(() => {
            this.errors.push("Current password wrong")
          });
      }
    },
    clearData() {
      this.inputValueOld = "";
      this.inputValueNew = "";
      this.inputValueConfirm = "";
    }
  }
};
</script>

<style scoped>
.headline {
  color: #4dbac0;
}
h3 {
  color: #4dbac0;
}
</style>